import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user\"><path d=\"M512 42.666667c153.173333 0 277.333333 124.16 277.333333 277.333333 0 93.653333-46.4 176.426667-117.461333 226.645333C823.978667 613.866667 938.666667 770.346667 938.666667 938.666667a42.666667 42.666667 0 1 1-85.333334 0c0-176.725333-164.608-341.333333-341.333333-341.333334-176.725333 0-341.333333 164.608-341.333333 341.333334a42.666667 42.666667 0 1 1-85.333334 0c0-168.341333 114.709333-324.8 266.794667-392.021334A276.970667 276.970667 0 0 1 234.666667 320c0-153.173333 124.16-277.333333 277.333333-277.333333z m0 85.333333a192 192 0 1 0 0 384 192 192 0 0 0 0-384z\" p-id=\"49115\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/user.svg
// module id = EOg8
// module chunks = 1